// extracted by mini-css-extract-plugin
export default {"error-screen":"V0Ru7","error-screen__screen":"Vmk27","error-screen__screen_only-title":"rTuB0"};